export type TimeZone = string;
interface TzInfo {
  name: string;
  zone_name: string;
  offset: string;
}
const allTimeZones: TzInfo[] = [
  { name: 'American Samoa', zone_name: 'Pacific/Pago_Pago', offset: '-11:00' },
  { name: 'International Date Line West', zone_name: 'Pacific/Midway', offset: '-11:00' },
  { name: 'Midway Island', zone_name: 'Pacific/Midway', offset: '-11:00' },
  { name: 'Hawaii', zone_name: 'Pacific/Honolulu', offset: '-10:00' },
  { name: 'Alaska', zone_name: 'America/Juneau', offset: '-09:00' },
  { name: 'Pacific Time (US & Canada)', zone_name: 'America/Los_Angeles', offset: '-08:00' },
  { name: 'Tijuana', zone_name: 'America/Tijuana', offset: '-08:00' },
  { name: 'Arizona', zone_name: 'America/Phoenix', offset: '-07:00' },
  { name: 'Chihuahua', zone_name: 'America/Chihuahua', offset: '-07:00' },
  { name: 'Mazatlan', zone_name: 'America/Mazatlan', offset: '-07:00' },
  { name: 'Mountain Time (US & Canada)', zone_name: 'America/Denver', offset: '-07:00' },
  { name: 'Central America', zone_name: 'America/Guatemala', offset: '-06:00' },
  { name: 'Central Time (US & Canada)', zone_name: 'America/Chicago', offset: '-06:00' },
  { name: 'Guadalajara', zone_name: 'America/Mexico_City', offset: '-06:00' },
  { name: 'Mexico City', zone_name: 'America/Mexico_City', offset: '-06:00' },
  { name: 'Monterrey', zone_name: 'America/Monterrey', offset: '-06:00' },
  { name: 'Saskatchewan', zone_name: 'America/Regina', offset: '-06:00' },
  { name: 'Bogota', zone_name: 'America/Bogota', offset: '-05:00' },
  { name: 'Eastern Time (US & Canada)', zone_name: 'America/New_York', offset: '-05:00' },
  { name: 'Indiana (East)', zone_name: 'America/Indiana/Indianapolis', offset: '-05:00' },
  { name: 'Lima', zone_name: 'America/Lima', offset: '-05:00' },
  { name: 'Quito', zone_name: 'America/Lima', offset: '-05:00' },
  { name: 'Atlantic Time (Canada)', zone_name: 'America/Halifax', offset: '-04:00' },
  { name: 'Caracas', zone_name: 'America/Caracas', offset: '-04:00' },
  { name: 'Georgetown', zone_name: 'America/Guyana', offset: '-04:00' },
  { name: 'La Paz', zone_name: 'America/La_Paz', offset: '-04:00' },
  { name: 'Santiago', zone_name: 'America/Santiago', offset: '-04:00' },
  { name: 'Newfoundland', zone_name: 'America/St_Johns', offset: '-03:30' },
  { name: 'Brasilia', zone_name: 'America/Sao_Paulo', offset: '-03:00' },
  { name: 'Buenos Aires', zone_name: 'America/Argentina/Buenos_Aires', offset: '-03:00' },
  { name: 'Greenland', zone_name: 'America/Godthab', offset: '-03:00' },
  { name: 'Montevideo', zone_name: 'America/Montevideo', offset: '-03:00' },
  { name: 'Mid-Atlantic', zone_name: 'Atlantic/South_Georgia', offset: '-02:00' },
  { name: 'Azores', zone_name: 'Atlantic/Azores', offset: '-01:00' },
  { name: 'Cape Verde Is.', zone_name: 'Atlantic/Cape_Verde', offset: '-01:00' },
  { name: 'Casablanca', zone_name: 'Africa/Casablanca', offset: '+00:00' },
  { name: 'Dublin', zone_name: 'Europe/Dublin', offset: '+00:00' },
  { name: 'Edinburgh', zone_name: 'Europe/London', offset: '+00:00' },
  { name: 'Lisbon', zone_name: 'Europe/Lisbon', offset: '+00:00' },
  { name: 'London', zone_name: 'Europe/London', offset: '+00:00' },
  { name: 'Monrovia', zone_name: 'Africa/Monrovia', offset: '+00:00' },
  { name: 'UTC', zone_name: 'Etc/UTC', offset: '+00:00' },
  { name: 'Amsterdam', zone_name: 'Europe/Amsterdam', offset: '+01:00' },
  { name: 'Belgrade', zone_name: 'Europe/Belgrade', offset: '+01:00' },
  { name: 'Berlin', zone_name: 'Europe/Berlin', offset: '+01:00' },
  { name: 'Bern', zone_name: 'Europe/Zurich', offset: '+01:00' },
  { name: 'Bratislava', zone_name: 'Europe/Bratislava', offset: '+01:00' },
  { name: 'Brussels', zone_name: 'Europe/Brussels', offset: '+01:00' },
  { name: 'Budapest', zone_name: 'Europe/Budapest', offset: '+01:00' },
  { name: 'Copenhagen', zone_name: 'Europe/Copenhagen', offset: '+01:00' },
  { name: 'Ljubljana', zone_name: 'Europe/Ljubljana', offset: '+01:00' },
  { name: 'Madrid', zone_name: 'Europe/Madrid', offset: '+01:00' },
  { name: 'Paris', zone_name: 'Europe/Paris', offset: '+01:00' },
  { name: 'Prague', zone_name: 'Europe/Prague', offset: '+01:00' },
  { name: 'Rome', zone_name: 'Europe/Rome', offset: '+01:00' },
  { name: 'Sarajevo', zone_name: 'Europe/Sarajevo', offset: '+01:00' },
  { name: 'Skopje', zone_name: 'Europe/Skopje', offset: '+01:00' },
  { name: 'Stockholm', zone_name: 'Europe/Stockholm', offset: '+01:00' },
  { name: 'Vienna', zone_name: 'Europe/Vienna', offset: '+01:00' },
  { name: 'Warsaw', zone_name: 'Europe/Warsaw', offset: '+01:00' },
  { name: 'West Central Africa', zone_name: 'Africa/Algiers', offset: '+01:00' },
  { name: 'Zagreb', zone_name: 'Europe/Zagreb', offset: '+01:00' },
  { name: 'Zurich', zone_name: 'Europe/Zurich', offset: '+01:00' },
  { name: 'Athens', zone_name: 'Europe/Athens', offset: '+02:00' },
  { name: 'Bucharest', zone_name: 'Europe/Bucharest', offset: '+02:00' },
  { name: 'Cairo', zone_name: 'Africa/Cairo', offset: '+02:00' },
  { name: 'Harare', zone_name: 'Africa/Harare', offset: '+02:00' },
  { name: 'Helsinki', zone_name: 'Europe/Helsinki', offset: '+02:00' },
  { name: 'Jerusalem', zone_name: 'Asia/Jerusalem', offset: '+02:00' },
  { name: 'Kaliningrad', zone_name: 'Europe/Kaliningrad', offset: '+02:00' },
  { name: 'Kyiv', zone_name: 'Europe/Kiev', offset: '+02:00' },
  { name: 'Pretoria', zone_name: 'Africa/Johannesburg', offset: '+02:00' },
  { name: 'Riga', zone_name: 'Europe/Riga', offset: '+02:00' },
  { name: 'Sofia', zone_name: 'Europe/Sofia', offset: '+02:00' },
  { name: 'Tallinn', zone_name: 'Europe/Tallinn', offset: '+02:00' },
  { name: 'Vilnius', zone_name: 'Europe/Vilnius', offset: '+02:00' },
  { name: 'Baghdad', zone_name: 'Asia/Baghdad', offset: '+03:00' },
  { name: 'Istanbul', zone_name: 'Europe/Istanbul', offset: '+03:00' },
  { name: 'Kuwait', zone_name: 'Asia/Kuwait', offset: '+03:00' },
  { name: 'Minsk', zone_name: 'Europe/Minsk', offset: '+03:00' },
  { name: 'Moscow', zone_name: 'Europe/Moscow', offset: '+03:00' },
  { name: 'Nairobi', zone_name: 'Africa/Nairobi', offset: '+03:00' },
  { name: 'Riyadh', zone_name: 'Asia/Riyadh', offset: '+03:00' },
  { name: 'St. Petersburg', zone_name: 'Europe/Moscow', offset: '+03:00' },
  { name: 'Volgograd', zone_name: 'Europe/Volgograd', offset: '+03:00' },
  { name: 'Tehran', zone_name: 'Asia/Tehran', offset: '+03:30' },
  { name: 'Abu Dhabi', zone_name: 'Asia/Muscat', offset: '+04:00' },
  { name: 'Baku', zone_name: 'Asia/Baku', offset: '+04:00' },
  { name: 'Muscat', zone_name: 'Asia/Muscat', offset: '+04:00' },
  { name: 'Samara', zone_name: 'Europe/Samara', offset: '+04:00' },
  { name: 'Tbilisi', zone_name: 'Asia/Tbilisi', offset: '+04:00' },
  { name: 'Yerevan', zone_name: 'Asia/Yerevan', offset: '+04:00' },
  { name: 'Kabul', zone_name: 'Asia/Kabul', offset: '+04:30' },
  { name: 'Ekaterinburg', zone_name: 'Asia/Yekaterinburg', offset: '+05:00' },
  { name: 'Islamabad', zone_name: 'Asia/Karachi', offset: '+05:00' },
  { name: 'Karachi', zone_name: 'Asia/Karachi', offset: '+05:00' },
  { name: 'Tashkent', zone_name: 'Asia/Tashkent', offset: '+05:00' },
  { name: 'Chennai', zone_name: 'Asia/Kolkata', offset: '+05:30' },
  { name: 'Kolkata', zone_name: 'Asia/Kolkata', offset: '+05:30' },
  { name: 'Mumbai', zone_name: 'Asia/Kolkata', offset: '+05:30' },
  { name: 'New Delhi', zone_name: 'Asia/Kolkata', offset: '+05:30' },
  { name: 'Sri Jayawardenepura', zone_name: 'Asia/Colombo', offset: '+05:30' },
  { name: 'Kathmandu', zone_name: 'Asia/Kathmandu', offset: '+05:45' },
  { name: 'Almaty', zone_name: 'Asia/Almaty', offset: '+06:00' },
  { name: 'Astana', zone_name: 'Asia/Dhaka', offset: '+06:00' },
  { name: 'Dhaka', zone_name: 'Asia/Dhaka', offset: '+06:00' },
  { name: 'Urumqi', zone_name: 'Asia/Urumqi', offset: '+06:00' },
  { name: 'Rangoon', zone_name: 'Asia/Rangoon', offset: '+06:30' },
  { name: 'Bangkok', zone_name: 'Asia/Bangkok', offset: '+07:00' },
  { name: 'Hanoi', zone_name: 'Asia/Bangkok', offset: '+07:00' },
  { name: 'Jakarta', zone_name: 'Asia/Jakarta', offset: '+07:00' },
  { name: 'Krasnoyarsk', zone_name: 'Asia/Krasnoyarsk', offset: '+07:00' },
  { name: 'Novosibirsk', zone_name: 'Asia/Novosibirsk', offset: '+07:00' },
  { name: 'Beijing', zone_name: 'Asia/Shanghai', offset: '+08:00' },
  { name: 'Chongqing', zone_name: 'Asia/Chongqing', offset: '+08:00' },
  { name: 'Hong Kong', zone_name: 'Asia/Hong_Kong', offset: '+08:00' },
  { name: 'Irkutsk', zone_name: 'Asia/Irkutsk', offset: '+08:00' },
  { name: 'Kuala Lumpur', zone_name: 'Asia/Kuala_Lumpur', offset: '+08:00' },
  { name: 'Perth', zone_name: 'Australia/Perth', offset: '+08:00' },
  { name: 'Singapore', zone_name: 'Asia/Singapore', offset: '+08:00' },
  { name: 'Taipei', zone_name: 'Asia/Taipei', offset: '+08:00' },
  { name: 'Ulaanbaatar', zone_name: 'Asia/Ulaanbaatar', offset: '+08:00' },
  { name: 'Osaka', zone_name: 'Asia/Tokyo', offset: '+09:00' },
  { name: 'Sapporo', zone_name: 'Asia/Tokyo', offset: '+09:00' },
  { name: 'Seoul', zone_name: 'Asia/Seoul', offset: '+09:00' },
  { name: 'Tokyo', zone_name: 'Asia/Tokyo', offset: '+09:00' },
  { name: 'Yakutsk', zone_name: 'Asia/Yakutsk', offset: '+09:00' },
  { name: 'Adelaide', zone_name: 'Australia/Adelaide', offset: '+09:30' },
  { name: 'Darwin', zone_name: 'Australia/Darwin', offset: '+09:30' },
  { name: 'Brisbane', zone_name: 'Australia/Brisbane', offset: '+10:00' },
  { name: 'Canberra', zone_name: 'Australia/Melbourne', offset: '+10:00' },
  { name: 'Guam', zone_name: 'Pacific/Guam', offset: '+10:00' },
  { name: 'Hobart', zone_name: 'Australia/Hobart', offset: '+10:00' },
  { name: 'Melbourne', zone_name: 'Australia/Melbourne', offset: '+10:00' },
  { name: 'Port Moresby', zone_name: 'Pacific/Port_Moresby', offset: '+10:00' },
  { name: 'Sydney', zone_name: 'Australia/Sydney', offset: '+10:00' },
  { name: 'Vladivostok', zone_name: 'Asia/Vladivostok', offset: '+10:00' },
  { name: 'Magadan', zone_name: 'Asia/Magadan', offset: '+11:00' },
  { name: 'New Caledonia', zone_name: 'Pacific/Noumea', offset: '+11:00' },
  { name: 'Solomon Is.', zone_name: 'Pacific/Guadalcanal', offset: '+11:00' },
  { name: 'Srednekolymsk', zone_name: 'Asia/Srednekolymsk', offset: '+11:00' },
  { name: 'Auckland', zone_name: 'Pacific/Auckland', offset: '+12:00' },
  { name: 'Fiji', zone_name: 'Pacific/Fiji', offset: '+12:00' },
  { name: 'Kamchatka', zone_name: 'Asia/Kamchatka', offset: '+12:00' },
  { name: 'Marshall Is.', zone_name: 'Pacific/Majuro', offset: '+12:00' },
  { name: 'Wellington', zone_name: 'Pacific/Auckland', offset: '+12:00' },
  { name: 'Chatham Is.', zone_name: 'Pacific/Chatham', offset: '+12:45' },
  { name: "Nuku'alofa", zone_name: 'Pacific/Tongatapu', offset: '+13:00' },
  { name: 'Samoa', zone_name: 'Pacific/Apia', offset: '+13:00' },
  { name: 'Tokelau Is.', zone_name: 'Pacific/Fakaofo', offset: '+13:00' },
];
export const AVAILABLE_TIMEZONE_NAMES: TimeZone[] = allTimeZones.map(tz => tz.zone_name);
const zonesByName: Map<string, [TzInfo]> = new Map();
allTimeZones.forEach(tz => {
  if (zonesByName.has(tz.zone_name)) {
    zonesByName.get(tz.zone_name)!.push(tz);
  } else {
    zonesByName.set(tz.zone_name, [tz]);
  }
});
export const AVAILABLE_TIMEZONES = Array.from(zonesByName.keys()).map(k => {
  const tzs = zonesByName.get(k)!;
  return { name: `${tzs.map(tz => tz.name).join('/')} ${tzs[0].offset}`, value: k };
});
export default TimeZone;
